export enum LS_KEYS {
    tmpPasswordEmail = 'tmpPasswordEmail',
    showTmpPasswordContactUs = 'showTmpPasswordContactUs',
    uuid = 'uuid',
    isUserFirstTimeOnMainPageAfterOB = 'isUserFirstTimeOnMainPageAfterOB',
    appAccessCode = 'appAccessCode',
    language = 'language',
    SOURCE = 'source',
    UTM_SOURCE = 'utmSource',
}

export const getLocalStorageKey = (key: string, defaultValue: any) => {
    try {
        const value = localStorage.getItem(key);

        return value ? JSON.parse(value) : defaultValue;
    } catch {
        return defaultValue;
    }
};

/**
 * `localStorage` wrapper that never throws (Safari private mode, blocked third-party storage, quota exceeded).
 * `getItem` returns `null` on failure, `setItem` returns `false`.
 */
export const safeStorage = {
    getItem: (key: string): string | null => {
        try {
            return localStorage.getItem(key);
        } catch {
            return null;
        }
    },
    setItem: (key: string, value: string): boolean => {
        try {
            localStorage.setItem(key, value);

            return true;
        } catch {
            return false;
        }
    },
};
